import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createVideo(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): VideoInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Video, parentId, masterBlockId),
    url: 'https://youtu.be/f48bbvvDJFQ',
    border: {
      radius: 8,
    },
    controls: true,
  }
}
